import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import UserMonthlyChartSharedAxis from "./UserMonthlyChartSharedAxis";

const UserMonthlyUsageMinutes = (props) => {
  const { userData, systemAverages } = props;
  const { /* user, */ session /* profile */ } = userData;
  const [datasets, setDatasets] = useState([]);

  useEffect(() => {
    if (
      session &&
      session.monthlySummary &&
      Array.isArray(systemAverages) &&
      systemAverages.length > 0
    ) {
      var datasets = [];

      var datasetLogin = {
        type: "bar",
        label: "Usage Time (minutes)",
        data: session.monthlySummary.map((value, index) => {
          return {
            x: moment(value.monthCode),
            y: Math.round(value.totalSessionSeconds / 60.0),
          };
        }),
      };
      datasets.push(datasetLogin);

      var datasetAverage = {
        type: "line",
        label: "System Average",
        lineTension: 0.3,
        data: systemAverages?.map((value, index) => {
          return {
            x: moment(value.monthCode),
            y: Math.round(value.averageSessionSeconds / 60.0),
          };
        }),
      };
      datasets.push(datasetAverage);

      setDatasets(datasets);
    }
  }, [session, systemAverages]);

  return (
    <>
      <UserMonthlyChartSharedAxis datasets={datasets} />
    </>
  );
};

export default UserMonthlyUsageMinutes;
